import { normalize, denormalize } from 'normalizr';
import { combineEpics, ofType } from 'redux-observable';
import {
  switchMap, catchError, mergeMap, map,
} from 'rxjs/operators';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { userSchema, usersSchema } from '../../../store/schema';
import {
  createUserSuccess,
  deleteUserSuccess,
  fetchAllSpaceMembersSuccess,
  fetchAllUsersSuccess,
  updateUserSuccess,
  fetchUserSuccess,
} from './actions';
import { entitiesFetchSuccess } from '../../../store/entities/actions';
import { getEntities } from '../../../store/entities/selectors';


const fetchAll = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL),
  switchMap(() => api.users.fetchAll().pipe(
    map((response) => normalize(response.body, usersSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllUsersSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const fetchAllAuthors = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL_AUTHORS),
  switchMap(() => api.users.fetchAllAuthors().pipe(
    map((response) => normalize(response.body, usersSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllUsersSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const fetchAllSpaceMembers = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL_SPACE_MEMBERS),
  switchMap((action) => api.users.fetchAllBySpaceId(action.spaceId).pipe(
    map((response) => normalize(response.body, usersSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllSpaceMembersSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const fetchUserEpic = (action$) => action$.pipe(
  ofType(actionTypes.FETCH),
  switchMap((action) => api.users.fetch(action.id).pipe(
    map((response) => normalize(response.body, userSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchUserSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),

);


const createUser = (action$, state$) => action$.pipe(
  ofType(actionTypes.CREATE),
  switchMap((action) =>
    api.users.create(denormalize(action.user, userSchema, getEntities(state$.value))).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, userSchema);
        return [
          entitiesFetchSuccess(entities),
          createUserSuccess(response.body),
        ];
      }),
      catchError((error) => [handleError(error)]),
    )),

);


const updateUser = (action$, state$) => action$.pipe(
  ofType(actionTypes.UPDATE),
  switchMap((action) =>
    api.users.update(denormalize(action.user, userSchema, getEntities(state$.value))).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, userSchema);
        return [
          entitiesFetchSuccess(entities),
          updateUserSuccess(action.user.id),
        ];
      }),
      catchError((error) => [handleError(error)]),
    )),

);


const deleteUser = (action$) => action$.pipe(
  ofType(actionTypes.DELETE),
  switchMap((action) => api.users.delete(action.user).pipe(
    mergeMap(() => [
      deleteUserSuccess(action.user.id),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);

export default combineEpics(
  fetchAllAuthors,
  fetchAll,
  fetchAllSpaceMembers,
  fetchUserEpic,
  createUser,
  updateUser,
  deleteUser,
);
